/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import Select from '@material-ui/core/Select';
import { defineMessages, injectIntl } from 'react-intl';
import InputLabel from '@material-ui/core/InputLabel';
import {
  Typography,
  FormControl,
  OutlinedInput,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const semesterIndex = ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const messages = defineMessages({
  semester: {
    id: 'Elearning.semester',
    defaultMessage: 'Semester',
  },
});

const renderSelectField = ({
  input,
  label,
  children,
  ...custom
}) => (
  <Select
    native
    {...input}
    {...custom}
    inputProps={{
      name: 'semester',
      id: 'semester-type',
    }}
    style={{ width: '100%' }}
    input={
      <OutlinedInput name="semester" labelWidth={110} id="semester-select" />
    }

  >
    {semesterIndex.map((index) => (
      <option
        key={index}
        value={index}
      >
        {index}
      </option>
    ))}
  </Select>
);

const ElearningSemester = (props) => {
  const { intl } = props;
  const [semester] = useState('');

  return (
    <>
      <Typography style={{ marginTop: '18px', marginBottom: '10px' }}>
        <InputLabel id="simple-select-label">
          {intl.formatMessage(messages.semester)}
        </InputLabel>
      </Typography>
      <FormControl style={{ width: '100%' }} variant="outlined">
        <InputLabel htmlFor="group-type">
          {intl.formatMessage(messages.semester)}
        </InputLabel>
        <Field
          name="semester"
          component={renderSelectField}
          label="semester-select"
          value={semester}
        />
      </FormControl>
    </>
  );
};

ElearningSemester.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return ({ initialValues: state.group.selectedGroup, form: name, dataform });
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,

})(injectIntl(ElearningSemester));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default (NewconnectedGroupForm);
